// Usuario.js
import React, { useState, useContext, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Spinner } from "react-bootstrap";
import { UserContext } from "./UserContext"; // Import UserContext
import PersonAvatar from "../0. Utilidades/PersonAvatar";

function Usuario() {
  const [showUserName, setShowUserName] = useState(false);
  const userInfo = useContext(UserContext); // Use UserContext to get userInfo
  const navigate = useNavigate();
  const userInfoRef = useRef();

  const handleUserIconClick = () => {
    if (userInfo.isLoading) return;
    setShowUserName(!showUserName);
  };

  const handleLogout = () => {
    const logoutUrl = "/custom_logout/";

    fetch(logoutUrl, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "logged_out") {
          navigate("/login/");
          window.location.reload(); // Force a reload of the page
        }
      })
      .catch((error) => console.error("Logout error:", error));
  };

  const handleClickOutside = (event) => {
    if (userInfoRef.current && !userInfoRef.current.contains(event.target)) {
      setShowUserName(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const roleClasses = [
    "btn-primary",
    "btn-success",
    "btn-danger",
    "btn-warning",
    "btn-info",
    "btn-light",
    "btn-dark",
  ];

  return (
    <div
      id="h_right"
      onClick={handleUserIconClick}
      style={{ cursor: userInfo.isLoading ? "wait" : "pointer", position: "relative" }}
    >
      {userInfo.isLoading ? (
        <span className="user-profile-avatar user-profile-loading" role="status" aria-label="Cargando datos de la usuaria">
          <Spinner animation="border" size="sm" aria-hidden="true" />
        </span>
      ) : (
        <PersonAvatar
          src={userInfo.image}
          name={userInfo.name}
          alt={`Fotografía de ${userInfo.name || "la usuaria"}`}
          className="user-profile-avatar"
          tone="profesional"
        />
      )}
      {showUserName && (
        <div className="user-info-tooltip" ref={userInfoRef}>
          <div className="text-center">
            <p>{userInfo.name}</p>
            <span>Roles:</span>
            <div>
              {userInfo.roles.map((role, index) => (
                <button
                  key={index}
                  className={`btn btn-sm m-1 ${roleClasses[index % roleClasses.length]}`}
                  disabled
                >
                  {role}
                </button>
              ))}
            </div>
            <button
              onClick={handleLogout}
              className="btn btn-secondary btn-sm mt-2"
            >
              Salir
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Usuario;
